/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
// import { setCurrentUser } from "../store/actions/authActions.js";
import { Button, Modal } from "flowbite-react";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import TableSearchBar from "../../components/TableSearchBar";
import instance, { fetchAllDepartments } from "../../api/api";
import { Loader } from "../../components/Loader";
import PerspectiveBadge from "../../components/PerspectiveBadge";
import { FormateDate } from "../../utils/FormatDate";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
  getSortedRowModel,
  SortingState,
} from "@tanstack/react-table";

type Risk = {
  id: string;
  riskNumber: string;
  riskName: string;
  perspective: string;
  objective: string;
  riskManagementPlan: string;
  actionOwner: string;
  startDate: string;
  monitaringDate: string;
  completionDate: string;
  responseText: string;
};

function AdminRiskManagement() {
  const [moveRisksModal, setMoveRisksModal] = useState(false);
  const [moreDetailsRequested, setMoreDetailsRequested] = useState(false);

  const [currentRiskDetails, setCurrentRiskDetails] = useState<any>([]);
  const [isLoadingRisks, setIsLoadingRisks] = useState(false);
  const [allRisks, setAllRisks] = useState<any[]>([]);

  const [isEditDrawerOpen, setIsEditDrawerOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState("");
  const [sorting, setSorting] = useState<SortingState>([
    { id: "riskNumber", desc: false },
  ]);

  const [isApprovingRisks, setIsApprovingRisks] = useState(false);
  // const [isClosingRisks, setIsClosingRisks] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const editDrawerRef = useRef<any>(null);

  const [departments, setDepartments] = useState<any[]>([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [highlightedRiskId, setHighlightedRiskId] = useState<any>(null);

  const closeDrawerRef = useRef<any>(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      setDepartments(await fetchAllDepartments());
    };
    fetchDepartments();
  }, []);

  const handleMoreDetailsRequest = async (e: any) => {
    e.preventDefault();
    setMoreDetailsRequested(!moreDetailsRequested);
  };
  const getAllRisks = async () => {
    try {
      setIsLoadingRisks(true);
      let riskRegisterResponse;
      if (selectedDepartment === "" || selectedDepartment === "All") {
        riskRegisterResponse = await instance.get(
          "/api/admin/riskRegister/riskRegisters/selections/ACTIVE_MANAGEMENT"
        );
      } else {
        riskRegisterResponse = await instance.get(
          `/api/admin/riskRegister/riskRegisters/department?departmentName=${selectedDepartment}`
        );
      }
      const riskManagement = await instance.get(
        "/api/admin/riskManagement/riskManagements/all"
      );
      setIsLoadingRisks(false);

      const riskResponse = await instance.get(
        "/api/admin/riskResponse/riskResponses/all/RESPONSE_APPROVED"
      );
      const riskRegister = riskRegisterResponse.data.data;
      const riskManagementData = riskManagement.data.data;
      const riskResponses = riskResponse.data.data;

      console.log("this is the management data: ", riskManagementData);
      console.log("this is the risk responses data: ", riskResponses);


      console.log(riskRegister)
      const combinedRisks = riskManagementData
        .filter((management: any) =>
          riskRegister.some((reg: any) => reg.id === management.riskRegisterId)
        )
        .filter((management: any) =>
          // Only include risks that have both management plan and action owner
          management.riskManagementPlan &&
          management.riskManagementPlan.trim() !== "" &&
          management.riskManagementPlan.trim() !== "--" &&
          management.actionOwner && 
          management.actionOwner.trim() !== "" &&
          management.actionOwner.trim() !== "--"
        )
        .map((management: any) => {
          console.log("this is the management::: ", management)
          const register = riskRegister.find(
            (reg: any) => reg.id === management.riskRegisterId
          );
          const response = riskResponses.find(
            (r: any) => r.riskRegisterId === management.riskRegisterId
          );

        // console.log("r:::", response);

        
        // console.log("the risk responses: ", riskResponses);

        // Find matching response for this risk register

        return {
          ...management,
          riskNumber: register?.riskNumber,
          riskName: register?.riskName,
          perspective: register?.perspective,
          source: register?.source,
          description: register?.description,
          rootCause: register?.rootCause,
          objective: register?.objective,
          responseText: response?.responseText ?? "",
          managementId: management ? management.id : "",
          riskManagementPlan: management ? management.riskManagementPlan : "",
          actionOwner: management ? management.actionOwner : "",
          startDate: management && management.startDate
            ? FormateDate(management.startDate)
            : "--",
          monitoringDate: management
            ? FormateDate(management.monitaringDate)
            : new Date(),
          monitoringDateRaw: management && management.monitaringDate
            ? new Date(management.monitaringDate).toISOString().split("T")[0]
            : "",
          completionDate: management
            ? FormateDate(management.completionDate)
            : "--",
          riskRegisterId: management ? management.riskRegisterId : "",
        };
      });

      console.log("these are the combined risks", combinedRisks);

      setAllRisks(combinedRisks);
    } catch (error) {
      setIsLoadingRisks(false);
      console.error(error);
    }
  };
  useEffect(() => {
    getAllRisks();
  }, [selectedDepartment]);

  const handleEditPlanDrawer = (riskId: string) => {
    const risk = allRisks.find((risk: Risk) => risk.id === riskId);
    setIsEditDrawerOpen(true);
    setCurrentRiskDetails(risk);
    setHighlightedRiskId(riskId);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        editDrawerRef.current &&
        !editDrawerRef.current.contains(event.target)
      ) {
        setIsEditDrawerOpen(false);
        setHighlightedRiskId(null);
      }
    };

    if (isEditDrawerOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      setHighlightedRiskId(null);
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isEditDrawerOpen]);

  const handlePageChange = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  // Calculate the items to display based on the current page and items per page
  const paginatedRisks = React.useMemo(() => {
    let risksToDisplay = allRisks;

    // Apply search filter
    if (searchTerm) {
      risksToDisplay = risksToDisplay.filter((risk: any) =>
        Object.values(risk).some((value) =>
          String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return risksToDisplay.slice(indexOfFirstItem, indexOfLastItem);
  }, [allRisks, currentPage, itemsPerPage, searchTerm]);

  const totalPages = Math.ceil(allRisks.length / itemsPerPage);

  // const closeRisk = async () => {
  //   setIsClosingRisks(true);
  //   try {
  //     // change the status to closed
  //     await instance.put(
  //       `/api/admin/riskRegister/update/status/${currentRiskDetails.riskRegisterId}`,
  //       {
  //         status: "CLOSED",
  //       }
  //     );

  //     // move the risk to the risk assessment stage
  //     await instance.post(
  //       `/api/admin/riskReassessments/riskReassessment/create/${currentRiskDetails.riskRegisterId}`,
  //       {
  //         reassessmentDate: new Date(),
  //       }
  //     );
  //     setIsClosingRisks(false);
  //     window.location.reload();
  //   } catch (error) {
  //     setIsClosingRisks(false);
  //     console.error(error);
  //   }
  // };
  const handleMoveRisksToNextStage = async () => {
    setIsApprovingRisks(true);
    try {
      for (const risk of allRisks) {
        if (
          risk.managementPlan !== "--" &&
          risk.managementPlan !== "" &&
          risk.actionOwner !== "--" &&
          risk.actionOwner !== ""
        ) {
          await instance.put(
        `/api/admin/riskRegister/update/status/${currentRiskDetails.riskRegisterId}`,
        {
          status: "COMPLETED",
        }
      );
          await instance.post(
            `/api/admin/riskReassessments/riskReassessment/create/${risk.riskRegisterId}`,
            {
              reassessmentDate: new Date(),
            }
          );
        }
      }
      setIsApprovingRisks(false);
      window.location.reload();
    } catch (error) {
      setIsApprovingRisks(false);
      console.error(error);
    }
  };

  const handleAddManagementPlan = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await instance.post(
        `/api/admin/riskManagement/riskManagements/create/${currentRiskDetails.riskRegisterId}`,
        {
          riskManagementPlan: currentRiskDetails.riskManagementPlan,
          actionOwner: currentRiskDetails.actionOwner,
          monitaringDate: currentRiskDetails.monitoringDateRaw
            ? new Date(currentRiskDetails.monitoringDateRaw)
            : currentRiskDetails.monitoringDate,
          completionDate: currentRiskDetails.completionDate,
        }
      );
      if (closeDrawerRef.current) {
        closeDrawerRef.current.click();
      }
      setIsSubmitting(false);
      await getAllRisks();
    } catch (error) {
      setIsSubmitting(false);
      return error;
    }
  };

  const columnHelper = createColumnHelper<Risk>();
  const columns = [
    columnHelper.accessor("riskNumber", {
      header: () => <span className="whitespace-nowrap">Risk Number</span>,
      cell: (info) => (
        <span className="whitespace-nowrap font-bold">
          {info.renderValue()}
        </span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskName", {
      header: () => <span className="whitespace-nowrap">Risk Name</span>,
      cell: (info) => info.getValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor((row) => row.perspective, {
      id: "perspective",
      cell: (info) => <PerspectiveBadge value={info.getValue()} />,
      header: () => <span>Perspective</span>,
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("objective", {
      header: () => "Objective",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("riskManagementPlan", {
      header: () => "Monitoring Plan",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("actionOwner", {
      header: () => "Action Owner",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("startDate", {
      header: () => <span className="whitespace-nowrap">Start Date</span>,
      cell: (info) => (
        <span className="whitespace-nowrap">{info.renderValue()}</span>
      ),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("monitaringDate", {
      header: () => "Monitoring Date",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.accessor("completionDate", {
      header: () => "Completion Date",
      cell: (info) => info.renderValue(),
      footer: (info) => info.column.id,
    }),
    columnHelper.display({
      id: "actions",
      header: () => <span>Actions</span>,
      cell: ({ row }) => (
        <button
          type="button"
          className="w-auto flex justify-center text-caribbeanCurrent items-center hover:text-black hover:bg-white hover:border-2 hover:border-caribbeanCurrent border border-caribbeanCurrent hover:bg-caribbeanCurrent focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-xs px-4 py-2 text-center inline-flex me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-caribbeanCurrent dark:focus:ring-blue-800 border-caribbeanCurrent text-black hover:bg-blue-800 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          data-drawer-target="drawer-edit-plan"
          data-drawer-show="drawer-edit-plan"
          data-drawer-placement="right"
          aria-controls="drawer-edit-plan"
          onClick={() => handleEditPlanDrawer(row.original.id)}
        >
          <svg
            className="w-4 h-4 text-white-800 dark:text-white me-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
            />
          </svg>
          Reschedule
        </button>
      ),
    }),
  ];

  const table = useReactTable<Risk>({
    data: paginatedRisks,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting,
    },
    onSortingChange: setSorting,
  });

  return (
    <>
      {/* <!-- Breadcrumb --> */}
      <nav
        className="justify-between  py-3 text-gray-700  sm:flex bg-gray-50"
        aria-label="Breadcrumb"
      >
        <ol className="inline-flex items-center mb-3 space-x-1 md:space-x-2 rtl:space-x-reverse sm:mb-0">
          <li>
            <div className="flex items-center">
              <NavLink
                to=""
                className="text-xl font-semibold text-gray-700 hover:text-blue-600  dark:text-gray-400 dark:hover:text-white"
              >
                Risk Monitoring Actions
              </NavLink>
            </div>
          </li>
        </ol>
      </nav>

      {/* <p className="text-caribbeanCurrent font-semibold">
          Due date: 14 September, 2024
        </p> */}
      <form className="flex max-w-sm my-4 justify-center items-center">
        <label
          htmlFor="countries"
          className="block mb-2 text-md font-medium text-gray-900 dark:text-white"
        >
          Department
        </label>
        <select
          id="countries"
          className="ml-5 bg-gray-50 border border-caribbeanCurrent  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          onChange={(e) => setSelectedDepartment(e.target.value)}
        >
          <option>All</option>
          {departments &&
            departments.map((department, index) => (
              <option key={index}>{department.name}</option>
            ))}
        </select>
      </form>

      <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4">
        <div className="p-5 text-lg font-semibold text-left rtl:text-right text-gray-900 bg-white dark:text-white dark:bg-gray-800 sticky top-0 z-20">
          <div className="w-full flex items-center justify-between">
            <p>Department Risks</p>
            <div className="flex flex-row gap-4 items-center justify-center">
              <div className="">
                <TableSearchBar
                  searchTerm={searchTerm}
                  onSearchChange={setSearchTerm}
                  placeholder="Search risks..."
                />
              </div>
            </div>
          </div>
        </div>
        <div className="rt-wrap relative sm:rounded-lg max-h-[calc(100vh-300px)] overflow-y-auto">
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
            <thead className="text-sm text-jet font-bold bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0 z-10">
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    const isSorted = header.column.getIsSorted();
                    return (
                      <th
                        scope="col"
                        key={header.id}
                        className="px-6 py-3"
                        aria-sort={
                          isSorted === "asc"
                            ? "ascending"
                            : isSorted === "desc"
                            ? "descending"
                            : "none"
                        }
                      >
                        {header.isPlaceholder ? null : (
                          <button
                            type="button"
                            className={`flex items-center gap-1 select-none ${
                              header.column.getCanSort()
                                ? "cursor-pointer"
                                : "cursor-default"
                            }`}
                            onClick={header.column.getToggleSortingHandler()}
                            title={
                              header.column.getCanSort() ? "Sort" : undefined
                            }
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                            {header.column.getCanSort() && (
                              <span className="text-xs">
                                {isSorted === "asc"
                                  ? "▲"
                                  : isSorted === "desc"
                                  ? "▼"
                                  : "⇅"}
                              </span>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            {isLoadingRisks ? (
              <tbody>
                <tr>
                  <td colSpan={7} className="text-center">
                    <div className="flex justify-center items-center h-96">
                      <Loader size={"xl"} />
                    </div>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="text-jet font-medium text-xs">
                {table.getRowModel().rows.map((row) => (
                  <tr
                    key={row.id}
                    className={`bg-gray border-b border-t hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 ${
                      highlightedRiskId === row.original.id ? "bg-gray-200" : ""
                    }`}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td className="px-6 py-4 align-top" key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            )}
          </table>

          {/* Pagination */}
          <div className="mt-4 pl-10 pr-10 pb-5 text-jet font-medium text-xs ">
            <nav aria-label="Page navigation">
              <ul className="flex justify-between">
                <li className="flex flex-row items-center">
                  <div>
                    <p>Show rows per page</p>
                  </div>
                  <div>
                    <select
                      className="ml-2 bg-gray-50 border border-caribbeanCurrent text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      onChange={(e) => setItemsPerPage(Number(e.target.value))}
                    >
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>
                  </div>
                </li>
                {/* {Array.from({ length: totalPages }, (_, index) => (
              <li key={index}>
                <button
                  className={`px-3 py-2 leading-tight ${
                    currentPage === index + 1
                      ? "text-blue-600 bg-blue-50 border border-blue-300"
                      : "text-gray-500 bg-white border border-gray-300"
                  } hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))} */}
                <li className="flex flex-row gap-1 items-center text-gray-500">
                  <div>
                    <p>
                      {currentPage} of {totalPages === 0 ? 1 : totalPages}
                    </p>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      {"<"}
                    </button>
                  </div>
                  <div>
                    <button
                      className="px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      {">"}
                    </button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* drawers */}

      {/* Risk Monitoring Edit Drawer */}
      {allRisks.length > 0 && (
        <div
          id="drawer-edit-plan"
          ref={editDrawerRef}
          className={`fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform ${
            isEditDrawerOpen ? "translate-x-0" : "translate-x-full"
          } bg-white w-full md:w-1/4 dark:bg-gray-800`}
          tabIndex={-1}
          aria-labelledby="drawer-edit-plan-item-label"
        >
          <h5
            id="drawer-label"
            className="inline-flex items-center mb-6 text-base font-semibold text-gray-500  dark:text-gray-400"
          >
            Risk Monitoring Edit
          </h5>
          <button
            type="button"
            data-drawer-hide="drawer-edit-plan"
            aria-controls="drawer-edit-plan"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
            ref={closeDrawerRef}
            onClick={() => setIsEditDrawerOpen(false)}
          >
            <svg
              className="w-3 h-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
              />
            </svg>
            <span className="sr-only">Close menu</span>
          </button>
          <form onSubmit={handleAddManagementPlan}>
            <div className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 mb-4 p-4">
              <div className="mb-6">
                <label
                  htmlFor="perspective"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Perspective
                </label>
                <input
                  type="text"
                  id="perspective"
                  value={currentRiskDetails.perspective}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Perspective goes here"
                  required
                  disabled
                  readOnly
                />
              </div>

              <div className="mb-6">
                <label
                  htmlFor="riskGoals"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Objective
                </label>
                <input
                  type="text"
                  id="objective"
                  value={currentRiskDetails.objective}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Objective goes here"
                  required
                  disabled
                  readOnly
                />
              </div>
              <div className="mb-6">
                <label
                  htmlFor="riskName"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Risk Name
                </label>
                <input
                  type="text"
                  id="riskName"
                  value={currentRiskDetails.riskName}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Risk title goes here"
                  required
                  disabled
                  readOnly
                />
              </div>
              {moreDetailsRequested && (
                <>
                  <div className="mb-6">
                    <label
                      htmlFor="source"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Source
                    </label>
                    <input
                      type="text"
                      id="source"
                      value={
                        currentRiskDetails.source
                          ? currentRiskDetails.source
                          : ""
                      }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Source goes here"
                      required
                      disabled
                      readOnly
                    />
                  </div>
                  <div className="mb-6">
                    <label
                      htmlFor="description"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Description
                    </label>
                    <textarea
                      readOnly
                      id="description"
                      rows={4}
                      disabled
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      value={currentRiskDetails.description}
                    ></textarea>
                  </div>
                  <div className="mb-6">
                    <label
                      htmlFor="rootCauses"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Root Causes
                    </label>
                    <textarea
                      id="rootCauses"
                      readOnly
                      rows={4}
                      disabled
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      value={currentRiskDetails.rootCause}
                    ></textarea>
                  </div>
                  <div className="mb-6">
                    <label
                      htmlFor="rootCauses"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Risk Response
                    </label>
                    <textarea
                      id="rootCauses"
                      readOnly
                      rows={4}
                      disabled
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder=""
                      value={currentRiskDetails.responseText}
                    ></textarea>
                  </div>
                </>
              )}
              <div className="mb-6 flex justify-center">
                <button
                  onClick={handleMoreDetailsRequest}
                  className="text-center font-bold text-caribbeanCurrent flex items-center"
                >
                  {moreDetailsRequested ? (
                    <>
                      Collapse{" "}
                      <span>
                        <IoIosArrowDown />
                      </span>
                    </>
                  ) : (
                    <>
                      See More Details{" "}
                      <span>
                        <IoIosArrowDown />
                      </span>
                    </>
                  )}
                </button>
              </div>

              {/* <div className="mb-6">
                <label
                  htmlFor="managementPlan"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Risk Monitoring Plan
                </label>
                <textarea
                  id="managementPlan"
                  rows={2}
                  className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Monitoring plan goes here..."
                  defaultValue={
                    currentRiskDetails.riskManagementPlan === "--"
                      ? ""
                      : currentRiskDetails.riskManagementPlan
                  }
                  onChange={(e) => {
                    setCurrentRiskDetails((prevState: any) => ({
                      ...prevState,
                      riskManagementPlan: e.target.value,
                    }));
                  }}
                ></textarea>
              </div> */}

              {/* <div className="mb-6">
                <label
                  htmlFor="actionOwner"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Action Owner
                </label>
                <input
                  type="text"
                  id="actionOwner"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Action owner goes here"
                  required
                  defaultValue={
                    currentRiskDetails.actionOwner === "--"
                      ? ""
                      : currentRiskDetails.actionOwner
                  }
                  onChange={(e) => {
                    setCurrentRiskDetails((prevState: any) => ({
                      ...prevState,
                      actionOwner: e.target.value,
                    }));
                  }}
                />
              </div> */}

              {/* <div className="mb-6">
                <label
                  htmlFor="deadline"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Start Date
                </label>
                <div className="flex border border-3 border-black rounded-lg items-center">
                  <div className="border p-2 rounded-tl-lg rounded-bl-lg bg-caribbeanCurrent text-white px-5 whitespace-nowrap">
                    Select Date
                  </div>
                  <div className="">
                    <input
                      defaultValue={currentRiskDetails.deadline}
                      onChange={(e) => {
                        setCurrentRiskDetails((prevState: any) => ({
                          ...prevState,
                          deadline: e.target.value,
                        }));
                      }}
                      className="w-full appearance-none flex justify-between border-0 border-none"
                      type="date"
                    ></input>
                  </div>
                </div>
              </div> */}

              {/* <div className="mb-6">
                <label
                  htmlFor="monitoringDate"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Monitoring Date
                </label>
                <div className="flex border border-3 border-black rounded-lg items-center">
                  <div className="border p-2 rounded-tl-lg rounded-bl-lg bg-caribbeanCurrent text-white px-5 whitespace-nowrap">
                    Select Date
                  </div>
                  <div className="">
                    <input
                      defaultValue={currentRiskDetails.monitoringDate}
                      onChange={(e) => {
                        setCurrentRiskDetails((prevState: any) => ({
                          ...prevState,
                          monitoringDate: e.target.value,
                        }));
                      }}
                      className="w-full appearance-none flex justify-between border-0 border-none"
                      type="date"
                    ></input>

                  </div>
                </div>
              </div> */}

              <div className="mb-6">
                <label
                  htmlFor="startDate"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Start Date
                </label>
                <input
                  type="text"
                  id="startDate"
                  value={currentRiskDetails.startDate ?? "--"}
                  className="bg-gray-50 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5 cursor-not-allowed dark:bg-gray-700 dark:border-gray-600 dark:text-gray-400"
                  disabled
                  readOnly
                />
              </div>

              <div className="mb-6">
                <label
                  htmlFor="monitoringDate"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Monitoring Date
                </label>
                <div className="flex border border-3 border-black rounded-lg items-center">
                  <div className="border p-2 rounded-tl-lg rounded-bl-lg bg-caribbeanCurrent text-white px-5 whitespace-nowrap">
                    Select Date
                  </div>
                  <div className="">
                    <input
                      defaultValue={currentRiskDetails.monitoringDateRaw}
                      onChange={(e) => {
                        setCurrentRiskDetails((prevState: any) => ({
                          ...prevState,
                          monitoringDateRaw: e.target.value,
                          monitoringDate: e.target.value,
                        }));
                      }}
                      className="w-full appearance-none flex justify-between border-0 border-none"
                      type="date"
                    ></input>
                  </div>
                </div>
              </div>

              <div className="">
                <label
                  htmlFor="completionDate"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Completion Date
                </label>
                <div className="flex border border-3 border-black rounded-lg items-center">
                  <div className="border p-2 rounded-tl-lg rounded-bl-lg bg-caribbeanCurrent text-white px-5 whitespace-nowrap">
                    Select Date
                  </div>
                  <div className="">
                    <input
                      defaultValue={currentRiskDetails.completionDate}
                      onChange={(e) => {
                        setCurrentRiskDetails((prevState: any) => ({
                          ...prevState,
                          completionDate: e.target.value,
                        }));
                      }}
                      className="w-full appearance-none flex justify-between border-0 border-none"
                      type="date"
                    ></input>
                    {/* <input type="date" className="appearance-none w-full pl-4 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" /> */}
                  </div>
                </div>
              </div>

              <div className="flex mt-6 gap-4">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className={`justify-center items-center inline-flex text-white bg-caribbeanCurrent hover:bg-white hover:text-caribbeanCurrent hover:border-2 hover:border-caribbeanCurrent w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block ${
                    isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {isSubmitting ? <Loader size="sm" /> : "Save"}
                </button>

                <button
                  type="button"
                  className="justify-center items-center inline-flex text-caribbeanCurrent border-2 border-caribbeanCurrent hover:bg-caribbeanCurrent hover:text-white w-full focus:ring-4 focus:ring-caribbeanCurrent font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-caribbeanCurrent dark:hover:bg-caribbeanCurrent focus:outline-none dark:focus:ring-caribbeanCurrent block"
                  data-drawer-hide="drawer-assessment-risk-score-item"
                  aria-controls="drawer-assessment-risk-score-item"
                  onClick={() => setIsEditDrawerOpen(false)}
                >
                  Cancel
                </button>
              </div>

              {/* <div className="mt-2">
                <button
                  type="button"
                  onClick={closeRisk}
                  disabled={isClosingRisks}
                  className={`w-full inline-flex justify-center items-center text-white bg-riskRed hover:bg-white hover:text-riskRed hover:border-2 hover:border-riskRed focus:ring-4 focus:ring-riskRed font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-riskRed dark:hover:bg-riskRed focus:outline-none dark:focus:ring-riskRed ${
                    isClosingRisks ? "opacity-60 cursor-not-allowed" : ""
                  }`}
                >
                  {isClosingRisks ? <Loader size="sm" /> : "Close Risk"}
                </button>
              </div> */}
            </div>
          </form>
        </div>
      )}

      <div className="border-2 border-dashed p-6 rounded-lg border-red-300 dark:border-gray-600 h-54 mb-4">
        <div className="space-y-6">
          <h3 className="text-riskRed font-medium text-lg">
            Move Risk To Reassessment Stage
          </h3>
          <Button
            onClick={() => setMoveRisksModal(true)}
            className="bg-riskRed font-bold"
          >
            Move Risks
          </Button>
          <Modal
            dismissible
            show={moveRisksModal}
            size="xl"
            onClose={() => setMoveRisksModal(false)}
            popup
          >
            {/* <Modal dismissible show={openModal} onClose={() => setOpenModal(false)}> */}
            <Modal.Header className="ml-3 p-5 border-b">
              <h4 className="font-bold text-gray-700 dark:text-gray-400">
                Move Risk To Reassessment Stage
              </h4>
            </Modal.Header>
            <Modal.Body>
              <div className="space-y-5 p-3">
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  Are you sure you want to promote these risks to the next
                  stage?
                </p>
                <p className="text-base leading-relaxed text-gray-700 dark:text-gray-400">
                  <span className="font-bold">Note: </span> You can't undo this
                  action
                </p>
              </div>
            </Modal.Body>
            <Modal.Footer className="border-t">
              <Button
                color="gray"
                className="border-none text-riskRed"
                onClick={() => setMoveRisksModal(false)}
              >
                Cancel
              </Button>
              <Button
                className="bg-riskRed hover:bg-riskRed"
                onClick={() => {
                  handleMoveRisksToNextStage();
                }}
              >
                {isApprovingRisks ? <Loader size="sm" /> : "Confirm"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default connect(
)(AdminRiskManagement);
